import { createSelector } from 'reselect';

export interface EditStoreState {
  store: any;
  loading: boolean;
}

export const initialState: EditStoreState = {
  store: {},
  loading: false,
};

const getEditStore = ({ editStore }: any): EditStoreState => editStore;

export const editStoreSelectors = {
  getEditStore: createSelector(
    getEditStore,
    ({ store }) => store,
  ),

  getLoading: createSelector(
    getEditStore,
    ({ loading }) => loading,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/EditStore/services/selectors.ts